import React, { Component, ReactNode } from "react";

import * as Sentry from "@sentry/react";

type PropsType = {
  children: ReactNode;
  fallback?: ReactNode;
};

type StateType = {
  hasError: boolean;
};

export class LexicalEditorErrorBoundary extends Component<
  PropsType,
  StateType
> {
  constructor(props: PropsType) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): StateType {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    Sentry.captureException(error, {
      tags: {
        component: "LexicalEditor",
        errorBoundary: "LexicalEditorErrorBoundary",
      },
      contexts: {
        react: {
          componentStack: errorInfo.componentStack,
        },
      },
    });
  }

  override render(): ReactNode {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className="rounded border border-red-300 bg-red-50 p-4 text-red-700">
            エディタでエラーが発生しました。ページを再読み込みしてください。
          </div>
        )
      );
    }

    return this.props.children;
  }
}
